import React from 'react';
import PropTypes from 'prop-types';
import SrBox from 'client/components/SrBox';
import SrTooltip, { SR_TOOLTIP_POSITION_CENTER } from 'client/components/SrTooltip';

const SrGoingToMarketJobIcon = ({ icon, color, text }) => {
  return (
    <SrTooltip
      icon={<SrBox borderBottom={`2px solid ${color}`}>{icon}</SrBox>}
      position={SR_TOOLTIP_POSITION_CENTER}
    >
      {text}
    </SrTooltip>
  );
};

SrGoingToMarketJobIcon.displayName = 'SrGoingToMarketJobIcon';

SrGoingToMarketJobIcon.propTypes = {
  icon: PropTypes.node.isRequired,
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default SrGoingToMarketJobIcon;
